module.exports = __webpack_public_path__ + "assets/img/d692-md.svg";